/*
 * iurop-about-story — Sobre Kawaii Café.
 * En móvil (Figma 30140:46790) "Conoce a la familia" es un CARRUSEL horizontal
 * con puntos de paginación: scroll-snap nativo + dots sincronizados.
 */
(function () {
  'use strict';
  function init() {
    var fam = document.querySelector('.kawaii-story__family');
    var dotsWrap = document.querySelector('[data-story-fam-dots]');
    if (!fam || !dotsWrap || fam.dataset.famInit) return;
    fam.dataset.famInit = '1';
    var cards = [].slice.call(fam.querySelectorAll('.kawaii-story__id'));
    if (cards.length < 2) return;

    cards.forEach(function (c, i) {
      var d = document.createElement('span');
      d.className = 'kawaii-story__family-dot' + (i === 0 ? ' is-on' : '');
      dotsWrap.appendChild(d);
    });
    var dots = [].slice.call(dotsWrap.children);

    function current() {
      var pitch = cards.length > 1
        ? cards[1].offsetLeft - cards[0].offsetLeft
        : fam.clientWidth;
      return Math.max(0, Math.min(cards.length - 1, Math.round(fam.scrollLeft / (pitch || 1))));
    }
    function update() {
      var i = current();
      dots.forEach(function (d, di) { d.classList.toggle('is-on', di === i); });
    }
    var raf = 0;
    fam.addEventListener('scroll', function () {
      // En pestaña oculta rAF no corre → actualizar en síncrono (testeable).
      if (document.hidden) { update(); return; }
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; update(); });
    }, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
